import { Button } from '@forwardflow/ui'
import { PreviousBillings } from './PreviousBillings'
import { NextBillingCycle } from './NextBillingCycle'
import { SavedCards } from './SavedCards'
import { useGetUserSubscription } from '@forwardflow/hooks/customHooks'

import { PauseSubscriptionModal } from '@forwardflow/modals/PauseSubscriptionModal'
import { usePauseSubscriptionModalStore } from '@forwardflow/store/modal/pauseSubscriptionModal'
import { useEffect, useState } from 'react'
import { UpdatePaymentModal } from '@forwardflow/modals/UpdatePaymentModal'
import { Skeleton } from 'antd'

const BillingAndSubscription = () => {
   const { data, isLoading } = useGetUserSubscription()
   const { openPauseSubscriptionModal } = usePauseSubscriptionModalStore()

   const [subscriptionStatus, setSubscriptionStatus] = useState(
      data?.organizationSubscription?.status
   )
   const toggleSubscriptionStatus = async () => {
      openPauseSubscriptionModal()
   }
   useEffect(() => {
      setSubscriptionStatus(data?.organizationSubscription?.status)
   }, [data?.organizationSubscription?.status])

   return (
      <div className="flex flex-col flex-1 px-10">
         <div className="flex items-center justify-between py-6 pl-10 pr-4">
            <span className="mr-4 font-medium">Billing and Subscription</span>
            <Button
               onClick={toggleSubscriptionStatus}
               className={`!h-10 !rounded px-7 !mt-0 max-w-60 ${
                  subscriptionStatus === 'active'
                     ? '!bg-danger/20 hover:!bg-danger/50 !border-danger'
                     : '!bg-primary/10'
               }`}
            >
               {subscriptionStatus === 'active' ? 'Pause' : 'Resume'}
               &nbsp; Subscription
            </Button>
         </div>
         {isLoading ? (
            <div className="flex flex-col gap-4">
               <Skeleton active />
            </div>
         ) : (
            <div className="bg-[#474747]/10 rounded-xl">
               <div className="flex items-center justify-between py-6 px-9 text-[20px] font-medium bg-[#474747]/10">
                  <span>Subscription</span>
                  <span className="text-primary">
                     $ {data?.organizationSubscription?.price} / month
                  </span>
               </div>
               <div className="flex items-center justify-between py-6 font-medium px-9">
                  <span>Plan ({data?.organizationSubscription?.name})</span>
                  <span className="text-primary text-[20px]">
                     $ {data?.organizationSubscription?.price} / month
                  </span>
               </div>
               <p className="border-b border-b-white/10 mx-9"></p>
               <div className="flex items-center justify-between py-6 font-medium px-9">
                  <span>Phone numbers ({data?.phoneNumbers?.count})</span>
                  <span className="text-primary text-[20px]">
                     $ {data?.phoneNumbers?.price} /{' '}
                     {data?.phoneNumbers?.period}
                  </span>
               </div>
            </div>
         )}
         {isLoading ? (
            <div className="flex flex-col gap-4">
               <Skeleton active />
            </div>
         ) : (
            <div className="bg-[#474747]/10 h-20 flex items-center border border-white/10 rounded-xl mt-7 py-5 px-6 justify-between">
               <p>
                  Credits balance:
                  <span className="text-[20px] font-medium">
                     {' $'}
                     {data?.creditInfo?.remainingCredits}
                  </span>
               </p>
               {/* <button
               onClick={openPurchaseCreditModal}
               className="px-5 py-2 transition-all border rounded bg-white/10 hover:bg-white/20 border-primary/10"
            >
               Purchase credits
            </button> */}
            </div>
         )}

         <div className="flex gap-5 mt-10">
            <SavedCards />
            <NextBillingCycle />
         </div>
         <PreviousBillings />
         <PauseSubscriptionModal />
         <UpdatePaymentModal />
      </div>
   )
}

export default BillingAndSubscription
